import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Logo } from "../components/Logo";
import { ArrowRight, Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen cherishlink-gradient-bg grid place-items-center p-6">
      <div className="text-center max-w-md">
        <div className="inline-block mb-10">
          <Logo size="lg" />
        </div>
        <div className="font-display text-[120px] leading-none font-bold tracking-tight text-primary/20">
          404
        </div>
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight" data-testid="not-found-title">
          We couldn't find that page.
        </h1>
        <p className="mt-3 text-muted-foreground">
          The page you're looking for may have moved, or perhaps you followed a broken link. Let's get you back home.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Button asChild className="rounded-full h-11 px-6" data-testid="not-found-home">
            <Link to="/"><Home className="h-4 w-4 mr-2" /> Back to home</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full h-11 px-6" data-testid="not-found-dashboard">
            <Link to="/dashboard">Go to dashboard <ArrowRight className="h-4 w-4 ml-2" /></Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
